module.exports = __webpack_public_path__ + "static/media/proposal_pickup_pin.17d7bf74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flavours/bubble/images/proposal_pickup_pin.svg
// module id = 639
// module chunks = 0